import { Link } from "react-router-dom";
import { ArrowUpRight, FileUp, PenLine } from "lucide-react";
import { useT } from "@/i18n";

export const GOV_SIGN_URL = "https://www.gov.pl/web/gov/podpisz-dokument-elektronicznie-wykorzystaj-podpis-zaufany";

function Tile({ icon: Icon, title, sub, accent, testId, ...rest }) {
  const Comp = rest.to ? Link : "a";
  return (
    <Comp
      data-testid={testId}
      {...rest}
      className={`group relative flex items-center gap-4 rounded-2xl border p-5 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl ${accent}`}
    >
      <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/30 group-hover:scale-105 transition-transform">
        <Icon size={28} strokeWidth={2.2} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block font-display font-bold text-base sm:text-lg leading-tight">{title}</span>
        <span className="block text-xs sm:text-sm opacity-85 mt-1 leading-snug">{sub}</span>
      </span>
      <ArrowUpRight size={18} className="opacity-70 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
    </Comp>
  );
}

export default function SignActions({ showUpload = true, compact = false }) {
  const { t } = useT();
  return (
    <div data-testid="sign-actions" className={`grid gap-3 ${showUpload ? "sm:grid-cols-2" : ""} ${compact ? "" : "mt-6"}`}>
      <Tile
        testId="sign-gov-link"
        href={GOV_SIGN_URL}
        target="_blank"
        rel="noopener noreferrer"
        icon={PenLine}
        title={t.upload.gov_title}
        sub={t.upload.gov_sub}
        accent="bg-brand-navy text-white border-brand-navy dark:bg-white dark:text-slate-900 dark:border-white"
      />
      {showUpload && (
        <Tile
          testId="upload-page-link"
          to="/biuro-wirtualne-warszawa/wyslij-podpisany-dokument"
          icon={FileUp}
          title={t.upload.title}
          sub={t.upload.tile_sub}
          accent="bg-brand-teal text-white border-brand-teal"
        />
      )}
    </div>
  );
}
